export default "__VITE_ASSET__913a8f7a__"